import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useLocation, useHistory } from 'react-router-dom'
import { useCookies } from 'react-cookie';
import { TabContent, TabPane, Nav, NavItem, Alert, Card, CardHeader, CardBody, CardFooter, Row, Col, Modal, ModalBody } from 'reactstrap';
import { toast } from 'react-toastify';
import { Input, Container } from 'reactstrap';
import PageSpinner from 'components/PageSpinner';
import { FaArrowLeft, FaCheck } from 'react-icons/fa';
import { toJpeg } from 'html-to-image';
import Carousel from 'react-grid-carousel';
import axios from 'axios';

const initialFormData = Object.freeze({
  name: '',
  description: '',
  awards: '',
  logo: '',
  schedule_1: '',
  schedule_2: '',
  schedule_3: '',
  schedule_4: '',
  schedule_5: '',
  website_url: '',
  finalists_url: '',
  judges_url: '',
  about_url: '',
  support_email: '',
  support_phone: '',
  host: '',
  host_description: '',
  start: '',
  location: '',
  dacast_url: '',
  vimeo_url: '',
  entry_guide_url: '',
  status: '',
});

const initialSeatViewData = Object.freeze({
  id: '',
});

const initialAttendeeData = Object.freeze({
  id: '',
  name: '',
  contact_number: '',
  company_name: '',
  company_position: ''
});

const initialVenueData = Object.freeze({
  venue_id: '',
  stage_length: '',
  stage_width: '',
  table_length: '',
  table_width: '',
  table_type: '',
  number_of_tables: '',
  total_seats_per_table: '',
  venue_name: '',
});

const initialResetFloorPlan = Object.freeze({
  floor_plan: '',
});

const initialTableData = Object.freeze({
  id: '',
  name: '',
});

const initialMoveAttendeeData = Object.freeze({
  attendee_ids_from: '',
  attendee_ids_to: '',
  table_number_from: '',
  table_number_to: '',
  user_id: '',
});

const AdminVenueSeatingPage = () => {
  let history = useHistory();
  const ref = useRef(null); // ref => { current: null }
  const stageRef = useRef(); // ref => { current: null }
  const [formData, setFormData] = useState(initialFormData);
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  }
  let query = useQuery();
  const award_id = query.get('award_id');
  const [award, setAward] = useState();

  const [cookies, setCookies, removeCookies] = useCookies(['currentUser', 'userRole', 'isLoggedIn', 'awardStatus', 'isWelcome', 'isFinalist', 'token', 'userDetails']);
  const currentUser = cookies.currentUser;
  const token = cookies.token;
  const isLoggedIn = cookies.isLoggedIn;
  let updatedAt = '';

  const isWarning = 'warning';
  const isSuccess = 'success';
  const isError = 'error';
  const toastCSS = {
    position: 'top-right',
    autoClose: 1500,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
  }
  const [attendeesListLoading, setAttendeesListLoading] = useState(false);
  const [attendees, setAttendees] = useState([]);
  const [seatingArrangementLoading, setSeatingArrangementLoading] = useState(false);
  const [reloadCount, setReloadCount] = useState(1);
  const [attendee, setAttendee] = useState(initialAttendeeData);
  const [venueData, setVenueData] = useState(initialVenueData);
  const [tables, setTables] = useState([]);
  const [numberOfSeats, setNumberOfSeats] = useState(0);
  const [tablesLoading, setTablesLoading] = useState(true);
  const [moveAttendeeData, setMoveAttendeeData] = useState(initialMoveAttendeeData);
  const [attendeeIdsFrom, setAttendeeIdsFrom] = useState([]);
  const [attendeeIdsTo, setAttendeeIdsTo] = useState([]);
  const [tableData, setTableData] = useState(initialTableData);
  const [table, setTable] = useState(initialTableData);
  const [tableModalShow, setTableModalShow] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [tableId, setTableId] = useState("");
 
  const [tableTo, setTableTo] = useState([]);
  const [tableFrom, setTableFrom] = useState([]);
  const [tableToSeats, setTableToSeats] = useState(0);
  const [tableFromSeats, setTableFromSeats] = useState(0);
  const [tableFromAttendees, setTableFromAttendees] = useState(0);
  const [selectAtleast, setSelectAtleast] = useState(true);
  const [moveAttendeeShow, setMoveAttendeeShow] = useState(false);
  const [tableIds, setTableIds] = useState([]);
  const [seatingArrangementModal, setSeatingArrangementModal] = useState(false);
  const [seatingImage, setSeatingImage] = useState();
  const [imageLoading, setImageLoading] = useState();

  const toggleTableModalShow = () => {
    setTableModalShow(!tableModalShow);
  }
  

  const getAward = async () => {
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/' + award_id + '?user_id=' + currentUser + '&token=' + token);
  }

  const getCheckSeat = async () => {
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/' + award_id + '/seat/check?user_id=' + currentUser + '&token=' + token);
  }

  const getTablesNew = async () => {
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/' + award_id + '/venue/table?user_id=' + currentUser + '&token=' + token);
  }

  const getAttendees = async () => {
    return await axios.get(process.env.REACT_APP_API_ENDPOINT + 'award/' + award_id + '/attendee?award_id=' + award_id + '&user_id=' + currentUser + '&token=' + token);
  }

  const toastAlert = ({ type, message }) => {
    if (type === 'error') {
      toast.error(message, toastCSS);
    } else if (type === 'warning') {
      toast.warning(message, toastCSS);
    } else {
      toast.success(message, toastCSS);
    }
  }

  const requestSuccess = () => {
    const message = 'Success!';
    toastAlert({ type: isSuccess, message: message });
  }

  const catchError = () => {
    const message = 'An error occured. Please try again or contact the administrator.';
    toastAlert({ type: isError, message: message });
  }

  const catchWarning = () => {
    const message = 'Something went wrong!';
    toastAlert({ type: isWarning, message: message });
  }

  const handleChangeAttendee = (e) => {
    const { name, value } = e.target;
    setAttendee({
      ...attendee,
      [name]: value,
    });
  }

  const submitSeatingImageCallback = useCallback(async () => {
    setImageLoading(() => true);
    await toJpeg(stageRef.current, { quality: 1.0 })
      .then(async (dataUrl) => {
        setSeatingImage(() => dataUrl);
        await submitSeatingImage(dataUrl);

      })
      .catch(() => {
        catchError();
      });

  }, [stageRef]);

  const toggleSeatingArrangement = e => {
    setSeatingArrangementModal(!seatingArrangementModal);
  }

  const retrieveHistory = async () => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'/seat/history?user_id=' + currentUser +'&token='+token, {
    // const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'/seating/history?award_id=' + award_id + '&user_id=' + currentUser +'&token='+token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const retrieveAttendeesSearch = async (e) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'/attendee?award_id='+award_id+'&user_id='+currentUser+'&token='+token+'&table_numbers='+tableIds+'&query='+e , {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const retrieveTablesSearch = async (e) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'/seat/plan?award_id='+award_id+'&user_id='+currentUser+'&token='+token+'&table_numbers='+tableIds+'&query='+e , {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const retrieveTables = async () => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'/venue/table?award_id='+award_id+'&user_id='+currentUser+'&token='+token , {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  async function submitSeatingImage(e) {
    const response = await fetch(process.env.REACT_APP_API_ENDPOINT + 'award/'+award_id+'?user_id=' + currentUser + '&token=' + token, {
      method: 'PUT', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
      body: JSON.stringify({
        user_id: currentUser,
        award_id: award_id,
        judge_allocation: e,
      }), // body data type must match "Content-Type" header
    })
    const json = await response.json();
    if (json.status == "Success") {
      setReloadCount(reloadCount + 1);
      setAttendeeIdsFrom([]);
      setAttendeeIdsTo([]);
      setTableTo([]);
      setTableFrom([]);
    }
  }

  const addTableNumber = (id) => {
    if (!tableIds.includes(id)) {
      setTableIds(tableIds => [...tableIds, id]);
    }
  }

  const removeTableNumber = (id) => {
    let filteredArray = tableIds.filter(item => item !== id);
    setTableIds(filteredArray);
  }

  const addAttendeeTo = (id) => {
    if (attendeeIdsTo.includes(id)) {
      console.log('User has already been selected!');
    } else {
      setAttendeeIdsTo(attendeeIdsTo => [...attendeeIdsTo, id]);
      setMoveAttendeeData({
        ...moveAttendeeData,
        user_id: currentUser,
        attendee_ids_to: attendeeIdsTo,
      });
      var attendee_ids_to = [...attendeeIdsTo, id];
      var seatsNeeded = ((tableToSeats - tableTo.length) - attendeeIdsFrom.length) + attendee_ids_to.length;
      if (seatsNeeded >= 0) {
        setSelectAtleast(false);
      } else {
        setSelectAtleast(true);
      }
    }
  }

  const removeAttendeeTo = (id) => {
    let filteredArray = attendeeIdsTo.filter(item => item !== id);
    setAttendeeIdsTo(filteredArray);
    setMoveAttendeeData({
      ...moveAttendeeData,
      user_id: currentUser,
      attendee_ids_to: filteredArray,
    });
    var seatsNeeded = ((tableToSeats - tableTo.length) - attendeeIdsFrom.length) + filteredArray.length;
    if (seatsNeeded >= 0) {
      setSelectAtleast(false);
    } else {
      setSelectAtleast(true);
    }
  }

  const retrieveTableTo = async (e) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'venue/table/'+e+'?award_id=' + award_id + '&user_id=' + currentUser +'&token='+token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const retrieveTable = async (e) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'venue/table/'+e+'?award_id=' + award_id + '&user_id=' + currentUser +'&token='+token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const retrieveTableFrom = async (e) => {
    const response = fetch(process.env.REACT_APP_API_ENDPOINT + 'venue/table/'+e+'?award_id=' + award_id + '&user_id=' + currentUser +'&token='+token, {
      method: 'GET', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, cors, *same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'omit', // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Credentials": true,
        'Content-Type': 'application/json',
        "Access-Control-Allow-Methods": "GET,HEAD,OPTIONS,POST,PUT",
        "Access-Control-Allow-Headers": "Access-Control-Allow-Headers, Origin,Accept, X-Requested-With, Content-Type, Access-Control-Request-Method, Access-Control-Request-Headers"
      },
      redirect: 'follow', // manual, *follow, error
      referrer: 'client', // no-referrer, *client
    })
      .then((response) => {
        return response.json();
      })
      .then((events) => {
        return events.data;
      });
    return response;
  };

  const handleTableFrom = (e) => {
    var table_id_from = e;
    setAttendeeIdsFrom([]);
    setMoveAttendeeData({
      ...moveAttendeeData,
      table_number_from: table_id_from,
    });

    const getTableFrom = async (table_id_from) => {
      const selectedTableFrom = await retrieveTableFrom(table_id_from);
      if(selectedTableFrom) {
        setTableFrom(selectedTableFrom.attendees);
        setTableFromSeats(selectedTableFrom.no_of_seats);
        setTableFromAttendees(selectedTableFrom.attendees.length);
      }
    };
    getTableFrom(table_id_from);

  }

  const handleChangeTable = (e) => {
    setTableData({
      ...tableData,
      [e.target.name]: e.target.value,
    });
  }

  const handleTableTo = (e) => {
    setAttendeeIdsTo([]);
    var table_id_to = e.target.value;

    if (table_id_to && table_id_to != "") {
      setMoveAttendeeData({
        ...moveAttendeeData,
        table_number_to: e.target.value,
      });
  
      const getTableTo = async (table_id_to) => {
        const selectedTableTo = await retrieveTableTo(table_id_to);
        if(selectedTableTo) {
          setTableTo(selectedTableTo.attendees);
          setMoveAttendeeShow(true);
          setTableToSeats(selectedTableTo.no_of_seats);
        }
      };
  
      getTableTo(table_id_to);
    }
  }

  const handleTable = (e) => {
    var table_id = e;
    setTableData({
      ...tableData,
      id: table_id,
    });
    setTableId(table_id);
    toggleTableModalShow();
    const getTable = async (table_id) => {
      const selectedTable = await retrieveTable(table_id);
      if(selectedTable) {
        setTable(selectedTable);
        setTableData({
          ...tableData,
          name: selectedTable.name,
        });
        setTableLoading(false);
      }
    };
    getTable(table_id);
  }

  const getTables = async () => {
    const selectedTables = await retrieveTables();
    if (selectedTables) {
      const tables = selectedTables.filter(table => table.category !== "other").map(x => x);
      let length = tables.length / 18;

      if (length % 1 > 0) {
        length++;
      }

      const sortedTable = tables.sort((a, b) => parseInt(a.name) - parseInt(b.name)).filter(table => table.category !== "other").map(x => x);

      let result = [];
      for (let i = length - length % 1; i > 0; i--) {
        result.push(sortedTable.splice(0, 18));
      }
      setTables(result);
      // setTablesPlan(selectedTables.tables);
      setSeatingArrangementLoading(false);
      setTablesLoading(false);
    }
  }

  useEffect(() => {
    if (!(isLoggedIn !== 'true' && window.location.pathname.includes('admin'))) {
      getAward().then(response => {
        const selectedAward = response.data.data;
        if (selectedAward) {
          setAward(selectedAward);

          setFormData({
            ...formData,
            name: selectedAward.name,
            logo: selectedAward.logo,
            website_url: selectedAward.website_url,
            description: selectedAward.description,
            support_email: selectedAward.support_email,
            support_phone: selectedAward.support_phone,
            event: selectedAward.event,
            entry_guide_url: selectedAward.event.entry_guide_url,
            status: selectedAward.status
          });
          setVenueData({
            ...venueData,
            venue_name: selectedAward.venue.name,
          });
          setTablesLoading(false);
        } else {
          catchWarning();
        }
      }).catch(() => {
        catchError();
      });
    }
  }, []);

  useEffect(() => {
    getTables();
  }, [reloadCount])

  useEffect(() => {
    if (isLoggedIn !== 'true' && window.location.pathname.includes('admin')) {
      window.location.href = "http://app.businessriver.com/";
    } else {
      const interval = setInterval( () => {
        getCheckSeat().then(response => {
          const result = response.data.seat_last_updated;
          if (result != updatedAt) {
            updatedAt = result;
            if (updatedAt) {
              getTables();
            }
          }
        }).catch(() => catchError());
      }, 8000);

      return () => clearInterval(interval);
    }
  }, []);

  const handleSearch = (e) => {
    const getTables = async (e) => {
      const selectedTables = await retrieveTablesSearch(e);
      if (selectedTables) {
        setTables(selectedTables.tables);
        setSeatingArrangementLoading(false);
        if (selectedTables.total_seats_per_table) {
          setNumberOfSeats(selectedTables.total_seats_per_table);
        }
        setTablesLoading(false);
      }
    };
    getTables(e);

    const getAttendees = async (e) => {
      const selectedAttendees = await retrieveAttendeesSearch(e);
      if (selectedAttendees) {
        setAttendeesListLoading(false);
        setAttendees(selectedAttendees);
      };
    };

    getAttendees(e);
  }

  return (
    <>
      {/*<section id="bis_award_tab">*/}
        <Container className={window.location.pathname.includes('venue/plan') ? 'h-100 mt-2' : 'mt-2'} fluid>
          {tablesLoading ?
            <>
              <PageSpinner />
            </>
            :
            <Row>
              <Col lg="12">
                <Card className={window.location.pathname.includes('venue/plan') ? 'border-0' : null}>
                  {!window.location.pathname.includes('venue/plan') ?
                    <div className='card-body py-2 px-4' style={{borderBottom: '1px solid #f2e7e7'}}>
                      {/*{window.location.pathname.includes('admin') ?*/}
                      {/*  <div className='text-right floor-plan-back'>*/}
                      {/*    <div className="bis-tooltip" onClick={() => history.goBack()}>*/}
                      {/*      /!* BACK *!/*/}
                      {/*      <FaArrowLeft className="text-black edit-icon" />*/}
                      {/*      /!* <span className="bis-tooltiptext">BACK</span> *!/*/}
                      {/*    </div>*/}
                      {/*  </div>*/}
                      {/*  :*/}
                      {/*  null*/}
                      {/*}*/}
                      <p className='floor-plan-font mb-0 d-flex justify-content-between align-items-center'>
                        <img src={formData.logo} style={{height: '50px'}}/>
                        <div>
                          <span style={{fontSize: '20px', fontWeight: '700'}}>Seating Plan</span>
                          <div className="floor-plan-font-divider"></div>
                          {venueData.venue_name && venueData.venue_name != "" ?
                            <p className="floor-plan-subfont mb-0" style={{fontSize: '10px', marginTop: '6px'}}>{award.venue.name}</p>
                            :
                            null
                          }
                        </div>
                      </p>
                    </div>
                    :
                    null
                  }
                  <CardBody className='py-1'>
                      {tables.length > 0 ?
                        <>
                          {/* Descending */}
                          <Carousel cols={1} rows={1} containerStyle={{maxWidth: '100%', marginBottom: '0.5rem'}} showDots={false} hideArrow={true}  loop dotColorActive='#1ec2f3' autoplay={10000}>
                            {tables.map((x, index) => (
                              <Carousel.Item>
                                <Row>
                                  {x.map(({ id, image, name, no_of_seats, company_name, attendees }) => (
                                    <Col lg="2" className="mb-1" key={"attendee-table-"+index}>
                                      <Card className="h-100">
                                        <CardHeader className='py-0 px-1'>
                                          {/*<Row>*/}
                                          {/*  <Col lg="12">*/}
                                              <h5 className="modal-title d-inline text-uppercase text-left" style={{fontSize: '0.75vw'}}>Table {name}</h5>
                                          {/*  </Col>*/}
                                          {/*</Row>*/}
                                        </CardHeader>
                                        <CardBody className='py-0 px-1'>
                                          {attendees.length > 0 ?
                                            <>
                                              {attendees.map((user, user_index) => {
                                                return (
                                                  <>
                                                    <div className="mb-0 d-flex justify-content-between">
                                                      <div
                                                        className='d-flex align-items-center'
                                                      >
                                                        <span className='attendee-box taken mr-1' style={{height: '0.75vw', width: '0.75vw'}}></span>
                                                        <span
                                                          style={{
                                                            fontSize: '0.75vw',
                                                            textOverflow: 'ellipsis',
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            width: '5vw'
                                                          }}>
                                                        {user.first_name && user.last_name ?
                                                          user.first_name + ' ' + user.last_name
                                                          : user.first_name ?
                                                            user.first_name
                                                            : user.last_name ?
                                                              user.last_name
                                                              :
                                                              'Reserved'
                                                        }
                                                        </span>
                                                      </div>
                                                      <div className='text-right'
                                                           style={{
                                                              fontSize: '0.75vw',
                                                              textOverflow: 'ellipsis',
                                                              whiteSpace: 'nowrap',
                                                              overflow: 'hidden',
                                                              width: '5vw'
                                                            }}>
                                                        {user.company_name}
                                                      </div>
                                                    </div>

                                                  </>
                                                )
                                              })}
                                              {(function (rows, i, len) {
                                                while (++i <= len) {
                                                  rows.push(
                                                    <div className="mb-0 d-flex align-items-center" style={{fontSize: '0.75vw'}}>
                                                      <span className='attendee-box available mr-1' style={{height: '0.75vw', width: '0.75vw'}}></span>
                                                      <span>Available</span>
                                                    </div>
                                                  )
                                                }
                                                return rows;
                                              })([], attendees.length, no_of_seats)}
                                            </>
                                            :
                                            <>
                                              {(function (rows, i, len) {
                                                while (++i <= len) {
                                                  rows.push(
                                                    <div className="mb-0 d-flex align-items-center" style={{fontSize: '0.7vw'}}>
                                                      <span className='attendee-box available mr-1' style={{height: '0.7vw', width: '0.7vw'}}></span>
                                                      <span>Available</span>
                                                    </div>
                                                  )
                                                }
                                                return rows;
                                              })([], 0, no_of_seats)}
                                            </>
                                          }
                                        </CardBody>
                                      </Card>
                                    </Col>
                                  ))}
                                </Row>
                              </Carousel.Item>
                            ))}
                          </Carousel>
                          {/*{tables.sort((a, b) => parseInt(a.name) - parseInt(b.name)).filter(table => table.category !== "other").map(({ id, image, name, no_of_seats, company_name, attendees }, index) => (*/}
                          {/*  <Col lg="4" className="mb-3" key={"attendee-table-"+index}>*/}
                          {/*    <Card className="h-100">*/}
                          {/*      <CardHeader>*/}
                          {/*        <Row>*/}
                          {/*          <Col lg="12">*/}
                          {/*            <h5 className="modal-title d-inline text-uppercase text-left">Table {name}</h5>*/}
                          {/*          </Col>*/}
                          {/*        </Row>*/}
                          {/*      </CardHeader>*/}
                          {/*      <CardBody>*/}
                          {/*        {attendees.length > 0 ?*/}
                          {/*          <>*/}
                          {/*            {attendees.map((user, user_index) => {*/}
                          {/*              return (*/}
                          {/*                <>*/}
                          {/*                  <div className="mb-2 d-flex justify-content-between">*/}
                          {/*                    <div className='d-flex align-items-center'>*/}
                          {/*                      <span className='attendee-box taken mr-1'></span>*/}
                          {/*                      {user.first_name && user.last_name ?*/}
                          {/*                        <span> {user.first_name} {user.last_name}</span>*/}
                          {/*                        : user.first_name ?*/}
                          {/*                          <span> {user.first_name}</span>*/}
                          {/*                          : user.last_name ?*/}
                          {/*                            <span> {user.last_name}</span>*/}
                          {/*                            :*/}
                          {/*                            <span> Reserved</span>*/}
                          {/*                      }*/}
                          {/*                    </div>*/}
                          {/*                    <div className='text-right'>*/}
                          {/*                      {user.company_name}*/}
                          {/*                    </div>*/}
                          {/*                  </div>*/}

                          {/*                </>*/}
                          {/*              )*/}
                          {/*            })}*/}
                          {/*            {(function (rows, i, len) {*/}
                          {/*              while (++i <= len) {*/}
                          {/*                rows.push(*/}
                          {/*                  <div className="mb-2">*/}
                          {/*                    <span className='attendee-box available mr-1'></span>*/}
                          {/*                    <span>Available</span>*/}
                          {/*                  </div>*/}
                          {/*                )*/}
                          {/*              }*/}
                          {/*              return rows;*/}
                          {/*            })([], attendees.length, no_of_seats)}*/}
                          {/*          </>*/}
                          {/*          :*/}
                          {/*          <>*/}
                          {/*            {(function (rows, i, len) {*/}
                          {/*              while (++i <= len) {*/}
                          {/*                rows.push(*/}
                          {/*                  <div className="attendee-container available mb-2">*/}
                          {/*                    <span>Available</span>*/}
                          {/*                  </div>*/}
                          {/*                )*/}
                          {/*              }*/}
                          {/*              return rows;*/}
                          {/*            })([], 0, no_of_seats)}*/}
                          {/*          </>*/}
                          {/*        }*/}
                          {/*      </CardBody>*/}
                          {/*    </Card>*/}
                          {/*  </Col>*/}
                          {/*))}*/}
                        </>
                        :
                        <div lg={12}>
                          <p className="mb-0 text-center">No records found</p>
                        </div>
                      }
                    {/*  </CardBody>*/}
                    {/*</Card>*/}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          }
        </Container>
        
      {/*</section>*/}
    </>
  )
}

export default AdminVenueSeatingPage;
